import {createContext} from 'react';
import type {LabelControlsType} from './LabelControls';
import type {BindingDropdownButtonControlsType} from './BindingDropdownButtonControls';
import type {BindingTopLevelOptionsType} from './BindingTopLevelOptions';
import type {CustomBindingSelectButtonType} from './CustomBindingSelectButton';
import type {ListActionControlsType} from './ListActionControls';
import type {TopLevelOptionsContext} from '@packages/systems/ExpressionEditor-utils-ui';

/**
 * The context itself lives here, apart from the entrypoint, so that each
 * customization file can read it without importing from `index.ts` — which
 * would make every customization part of an import cycle. The customization
 * types are imported here as types only, so this module has no runtime
 * dependency on them.
 */
export type CustomControlsType = {
  LabelControls: LabelControlsType;
  BindingDropdownButtonControls: BindingDropdownButtonControlsType;
  BindingTopLevelOptions: BindingTopLevelOptionsType;
  CustomBindingSelectButton: CustomBindingSelectButtonType;
  TopLevelOptionsContext?: TopLevelOptionsContext;
  // Optional so the existing providers that build a full CustomControlsType
  // literal don't all have to change to opt out of list actions.
  ListActionControls?: ListActionControlsType;
};

export const defaultCustomControlsValue: CustomControlsType = {
  LabelControls: [],
  BindingDropdownButtonControls: null,
  BindingTopLevelOptions: null,
  CustomBindingSelectButton: null,
};

export const CustomControls = createContext<CustomControlsType>(
  defaultCustomControlsValue
);
